import React from "react"
import { Box, Modal, ModalDisclosure, Stack, useModalState } from "@mos-cat/ds"
import { ColorPicker } from "."
import { Field, Form } from "react-final-form"
import { Button, Message } from "@dit/core-frontend"
import { Error as Close, Success as Save } from "@mos-cat/ds-icons"

const ColorPickerModal = ({
  children,
  modalDisclosureProps,
  modalStateProps,
  color,
  onChangeColor,
}) => {
  const modalState = useModalState()
  const getModalState = { ...modalState, ...modalStateProps }
  const isVisible = getModalState?.visible

  const handleClose = () => {
    getModalState.hide()
  }
  return (
    <>
      {children && (
        <ModalDisclosure {...modalDisclosureProps} {...getModalState}>
          {children}
        </ModalDisclosure>
      )}
      <Modal
        {...getModalState}
        heading="Выбор цвета ячейки"
        modalSize="small"
        styles={{
          "&[role='dialog']": {
            width: "27rem !important",
          },
        }}
      >
        {isVisible && (
          <Form
            initialValues={{
              color: color,
            }}
            onSubmit={async (values) => {
              onChangeColor(values.color)
              getModalState.hide()
            }}
            render={({ handleSubmit, submitting, form, submitErrors, dirtySinceLastSubmit }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <Stack minHeight="200px">
                    <Message
                      type="error"
                      isAlwaysVisible
                      isVisible={!dirtySinceLastSubmit}
                      text={Object.values(submitErrors || {})}
                    />
                    <Field name="color">
                      {() => (
                        <>
                          <ColorPicker
                            color={color}
                            onChange={(selected) => {
                              form.change("color", selected)
                            }}
                          />
                        </>
                      )}
                    </Field>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-end"
                      gridGap="10px"
                    >
                      <Button
                        backgroundColor="var(--error-30)"
                        kind="borderless"
                        type="reset"
                        onClick={handleClose}
                      >
                        <Close width={22} height={22} />
                      </Button>
                      <Button
                        kind="borderless"
                        type="submit"
                        disabled={submitting}
                        backgroundColor="var(--success-30)"
                      >
                        <Save width={22} height={22} />
                      </Button>
                    </Box>
                  </Stack>
                </form>
              )
            }}
          />
        )}
      </Modal>
    </>
  )
}

export default ColorPickerModal
